import { useEffect, useState, useMemo } from 'react';
import { withFormik } from 'formik';
import { Redirect } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import compose from 'recompose/compose';

import { useStorage64, useGiftTableInfo } from 'hooks';
import { useStore } from 'store';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { Tabs, Select } from 'components';
import { TableHero } from 'components/gifts-table';
import { withAgentPage, withLayout } from 'hocs';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';

import { removeStorage } from 'functions/storageBase64';
import DeleteTableFlux from './DeleteTableFlux';
import { LIST_OF_SECTIONS, LIST_OF_SECTIONS_WITHOUT_COUPON, OPTIONS_OF_SECTIONS, OPTIONS_OF_SECTIONS_WITHOUT_COUPON } from './config';
import styles from './styles.module.scss';


const TableAdmin = ({ values, agentTableId, agentStaffId }) => {

  agentStaffId && removeStorage(CURRENT_GIFT_TABLE);
  
  const [showDeleteTableFlux, setShowDeleteTableFlux] = useState(false);
  const [storageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const { selectedSection = 0 } = values;

  const [tableInfo, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );

  const [giftTable] = useStore((state) => state.giftTable.giftTable);

  const { hasGiftTableAndIsLogged } = useGiftTableInfo();

  const tableId = useMemo(() => {
    if (agentStaffId && agentTableId) {
      return agentTableId;
    }

    return storageGiftTable.event || giftTable.id;
  }, [storageGiftTable.event, giftTable.id, agentTableId, agentStaffId]);

  const handleClickDeleteHero = () => {
    setShowDeleteTableFlux(true);
  };

  const handleClose = () => {
    setShowDeleteTableFlux(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if(tableId){
      // console.log('tableId', tableId)
      /* prueba de optimizacion */
      if (tableId) dispatch(fetchGiftTableInfo(tableId));
    }

  }, [tableId]);

  const disabledClose = (date) => {
    if (date.length) {
      const formatedDate = date;
      const datePresent = new Date().setHours(0,0,0,0);
      const dateEvent = new Date(formatedDate).setHours(0,0,0,0);
      return dateEvent >= datePresent;
    }
    return true;
  }
  const isValidCoupon = +tableInfo?.id <= 1665 ? false : tableInfo?.coupon ? true : !!tableInfo?.applyBonification;
  const { Section = null } = isValidCoupon ? LIST_OF_SECTIONS[selectedSection] : LIST_OF_SECTIONS_WITHOUT_COUPON[selectedSection] || {};
  const eventIsInFuture = disabledClose(tableInfo.date || '');
  const showDocumentation = tableInfo.upload_files_closing

  // console.log('hasGiftTableAndIsLogged: ',hasGiftTableAndIsLogged, ' agentStaffId: ', agentStaffId)

  if (!hasGiftTableAndIsLogged && !agentStaffId) {
    return <Redirect to="/" />;
    // return <Redirect to="/crear-mesa" />;
  }

  return (
    <>
      <DeleteTableFlux show={showDeleteTableFlux} onClose={handleClose} />

      <section className={styles.TableAdmin}>
        <TableHero
          image={tableInfo?.image}
          typeId={tableInfo?.type?.id}
          eventName={tableInfo?.type?.name}
          name={tableInfo?.name}
          date={tableInfo?.date}
          readOnly={tableInfo?.status === 'Cancel'}
          onDeleteHero={handleClickDeleteHero}
        />

        <Container className="mb-5">
          <div className="d-md-block">
            <Tabs
              id="my_table_tabs"
              listOfSections={isValidCoupon ? LIST_OF_SECTIONS : LIST_OF_SECTIONS_WITHOUT_COUPON}
              showDocumentation={showDocumentation}
              eventIsInFuture={eventIsInFuture}
              className={`${styles.tabContent} py-4 px-3`}
              tableInfo={tableInfo}
            />
          </div>
          {/*
            <Row className="d-flex d-md-none justify-content-start align-items-center">
              <Col xs={12}>
                <Select
                  name="selectedSection"
                  options={isValidCoupon ? OPTIONS_OF_SECTIONS : OPTIONS_OF_SECTIONS_WITHOUT_COUPON}
                  variant="primary"
                  showDocumentation={showDocumentation}
                  eventIsInFuture={eventIsInFuture}
                  defaultValue={selectedSection}
                />
              </Col>
              <Col xs={12} className>
                {Section && <Section />}
              </Col>
            </Row>
          */}
        </Container>
      </section>
    </>
  );
};

const mapPropsToValues = () => ({
  selectedSection: '0'
});

export default compose(
  withLayout,
  withAgentPage(),
  withFormik({ mapPropsToValues }),
)(TableAdmin);
